/* Meta pixel for the Joinbetter.com dataset: PageView on every page and CompleteRegistration on the thank-you page, only after Osano marketing consent. */
(function () {
  'use strict';

  var pixelId = '352337782601869';
  var eventIdKey = 'bh_meta_event_id_v1';
  var started = false;

  function consentAllowsPixel() {
    try {
      var consent = window.Osano.cm.getConsent();
      return consent.MARKETING === 'ACCEPT' && consent.OPT_OUT !== 'ACCEPT' &&
        navigator.globalPrivacyControl !== true;
    } catch (error) { return false; }
  }

  // A page that already queued its own PageView behind a consent revoke only needs that revoke lifted.
  function releaseExistingPixel(fbq) {
    if (fbq.callMethod) {
      fbq('consent', 'grant');
      return;
    }
    // Before the library loads, a queued grant waits behind the revoke forever: drop the revoke instead.
    fbq.queue = (fbq.queue || []).filter(function (args) {
      return !(args[0] === 'consent' && args[1] === 'revoke');
    });
  }

  // The form stored its browser ID as the event ID; the server's CompleteRegistration carries the same one, so Meta keeps a single event.
  function trackRegistration() {
    if (!/^\/pages\/lead-submitted/.test(window.location.pathname)) return;
    var eventId = '';
    try { eventId = window.sessionStorage.getItem(eventIdKey) || ''; } catch (error) {}
    if (!/^fb\.[0-9]+\.[0-9]{13}\.[0-9]+$/.test(eventId)) return;
    window.fbq('track', 'CompleteRegistration', {}, {eventID: eventId});
    try { window.sessionStorage.removeItem(eventIdKey); } catch (error) {}
  }

  function startPixel() {
    if (started || !consentAllowsPixel()) return;
    started = true;
    if (window.fbq) {
      releaseExistingPixel(window.fbq);
      trackRegistration();
      return;
    }
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v;
      s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // autoConfig off: no automatic events (button clicks, page metadata, scroll depth).
    window.fbq('set', 'autoConfig', false, pixelId);
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
    trackRegistration();
  }

  startPixel();
  try {
    // Osano announces a new choice only through its own emitter, never as a DOM event.
    window.Osano.cm.addEventListener('osano-cm-consent-saved', startPixel);
  } catch (error) { /* Without Osano there is no consent, so the pixel stays off. */ }
})();
